import * as React from 'react';

import {Body} from 'shells/typography/body';

import type {
    GetInboxStatus_inboxStatus as InboxStatus,
    GetInboundSmsRules_inboundSmsRules as InboundSmsRules,
} from 'nutshell-graphql-types';

import {getIsEnrolled, getIsPhoneStatusValid} from '../../../setup/text-messaging/helpers';

import {InboundSettings} from '../../inbound';

import {useUpdateInboundSmsRules} from '../graphql/hooks';

type Props = {
    inboxStatus: InboxStatus;
    inboundSmsRules: InboundSmsRules;
    refetch: () => Promise<any>;
};

export function InboundSmsSettingsWrapper(props: Props) {
    const {updateInboundSmsRules} = useUpdateInboundSmsRules();

    const isEnrolled = getIsEnrolled(props.inboxStatus);
    const isPhoneStatusValid = getIsPhoneStatusValid(props.inboxStatus);

    if (!isEnrolled || !isPhoneStatusValid) {
        return (
            <div className='background-offwhite-dk border br-3 flex flex-dir-col px-16 py-12'>
                <div className='flex flex-dir-col gap-2'>
                    <Body isBold={true} color='dark'>
                        SMS inbound rules
                    </Body>
                    <Body color='dark' size='small'>
                        After you successfuly enroll your brand, you can manage how new incoming
                        messages are handled
                    </Body>
                </div>
            </div>
        );
    }

    return (
        <div className='br-3 border'>
            <div className='background-offwhite-dk flex px-16 py-12 flex-dir-col'>
                <Body isBold={true} color='dark'>
                    SMS inbound rules
                </Body>
            </div>
            <div className='pad-16'>
                <Body>
                    Manage how first-time inbound text messages are assigned, create new leads, and
                    set up a phone number redirect for incoming calls. Use the settings below to
                    streamline communication and keep your team responsive and organized.
                </Body>
                <InboundSettings
                    inboundRules={props.inboundSmsRules}
                    updateInboundRules={updateInboundSmsRules}
                    refetch={props.refetch}
                    isEnrolled={isEnrolled}
                    threadType='SMS'
                />
            </div>
        </div>
    );
}
